import React, { useEffect, useState } from 'react'
import MySelect from '../../UI/form/MySelect'
import { responseError } from '../../../helpers/response/ResponseHelper'
import { getUserName } from '../../../helpers/user/UserHelper'
import { getSupplierUsersAPI } from '../../../api/user/userAPI'

// Отримання всіїх постачальників
const SupplierUsersSelectMain = ({ required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState(forciblyValue)
  	const [validSelect, setValidSelect] = useState(false)
	const [supplierUsers, setSupplierUsers] = useState([])

	useEffect(() => {
		getUsers()
	}, [])

	useEffect(() => {
		valid()
	}, [required, value])

	const getUsers = () => {
		getSupplierUsersAPI().then(data => {
			setSupplierUsers(data)
		}).catch(e => {
			// setError(responseError(e))
			console.error(responseError(e))
		})
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
				setValidSelect(true)
			} else {
				setValidate(false)
				setValidSelect(false)
			}
		} else {
			setValidate(true)
			setValidSelect(true)
		}
	}

  return (
    <MySelect
        value={value}
        label="Постачальники"
        labelId="select__supplierUsers-label"
        id='select__supplierUsers'
        onChange = {e => {
			setValueForm(e)
            setValue(e)
			// setEvent({...event, categoryId: e})
		}}
        nameField='Постачальники'
        // sx={{width: '200px'}}
        options={
			supplierUsers && supplierUsers.length > 0 ? 
				supplierUsers.map(user => {
            		return {id: user.id, name: getUserName({ user })}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default SupplierUsersSelectMain